import React from 'react';
import '../styles/Message.css';

const SUPPORTED_TYPES = new Set(['success', 'error', 'info', 'warning']);
const SUPPORTED_MODES = new Set(['inline', 'toast']);

const joinClassNames = (...parts) => parts.filter(Boolean).join(' ');

const Message = ({ text, type = 'info', mode = 'inline', className = '' }) => {
  if (!text) return null;

  const normalizedType = SUPPORTED_TYPES.has(type) ? type : 'info';
  const normalizedMode = SUPPORTED_MODES.has(mode) ? mode : 'inline';

  return (
    <div
      className={joinClassNames(
        'message-box',
        `message-box--${normalizedType}`,
        `message-box--${normalizedMode}`,
        className,
      )}
      role="status"
      aria-live="polite"
    >
      <div className="message-box__body">
        <span className="message-box__text">{text}</span>
      </div>
    </div>
  );
};

export default Message;
